import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import './GlobalBackButton.css';

const NO_BACK_ROUTES = ["/", "/dashboard", "/home", "/auth"];

const GlobalBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (NO_BACK_ROUTES.includes(location.pathname)) {
    return null;
  }

  const handleBack = () => {
    navigate(-1);
  };

  return (
    
    <Tooltip title="Go Back">
    <IconButton
        onClick={handleBack}
        sx={{
        position: "fixed",
        top: "95px",
        left: "20px",
        zIndex: 9999,
        backgroundColor: "#ffffff",
        color: "#AD26BF",
        border: "1px solid #ccc",
        "&:hover": {
            backgroundColor: "#f0f0f0",
        },
        }}
    >
        <ArrowBackIcon />
    </IconButton>
    </Tooltip>

  );
};

export default GlobalBackButton;
